import { ArrowRight, Check, FileSignature, FileUp, Loader2 } from "lucide-react";
import { StepHeader } from "./fields";

const CARDS = [
  {
    route: "medicys_sow",
    icon: FileSignature,
    title: "Sign the Medicys Statement of Work",
    body: "Our standard Statement of Work, built from this proposal. You add a few project and invoicing details, review the document and sign it online.",
    points: ["The signed PDF is emailed to you straight away", "Our Terms and Conditions of Business are included", "Work can be scheduled as soon as it is signed"],
  },
  {
    route: "client_paper",
    icon: FileUp,
    title: "Use your own contract",
    body: "Your own paperwork will govern the work: a master services agreement if one is in place with Medicys, or otherwise your Statement of Work, services agreement or purchase order.",
    points: ["Upload the draft here, or send it later by email", "Medicys reviews and follows up", "We still collect a few other details we need for setup"],
  },
];

export function RouteStep({ onChoose, busy }) {
  return (
    <div className="flex flex-col gap-8" data-testid="commission-route">
      <StepHeader
        eyebrow="Step 2 of 5 · Contract route"
        title="How would you like to contract?"
        intro="Thank you for confirming. Click the route that suits your organisation to continue. If you change your mind, you can switch on the next screen."
      />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {CARDS.map(({ route, icon: Icon, title, body, points }) => (
          <button
            key={route}
            type="button"
            disabled={busy}
            onClick={() => onChoose(route)}
            data-testid={`commission-route-${route}`}
            className="group relative text-left rounded-xl border-2 border-stone-300 bg-white p-6 sm:p-7 flex flex-col gap-5 cursor-pointer shadow-sm transition-[border-color,transform,box-shadow,background-color] hover:border-[#1B4F8A] hover:bg-[#1B4F8A]/[0.03] hover:-translate-y-1 hover:shadow-[0_22px_44px_-24px_rgba(27,79,138,0.55)] active:translate-y-0 focus-visible:outline-none focus-visible:border-[#1B4F8A] focus-visible:ring-4 focus-visible:ring-[#1B4F8A]/15 disabled:opacity-50 disabled:hover:translate-y-0"
          >
            <div className="flex items-start justify-between gap-4">
              <span className="w-11 h-11 rounded-md bg-[#0B1220] text-[#3EA8DC] flex items-center justify-center shrink-0">
                <Icon className="w-5 h-5" />
              </span>
              <span
                aria-hidden
                className="w-11 h-11 rounded-full border-2 border-[#1B4F8A] text-[#1B4F8A] bg-white flex items-center justify-center shrink-0 transition-[background-color,color,transform] group-hover:bg-[#1B4F8A] group-hover:text-white group-hover:translate-x-1"
                data-testid={`commission-route-${route}-go`}
              >
                {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <ArrowRight className="w-5 h-5" />}
              </span>
            </div>
            <div>
              <h3 className="font-serif text-2xl text-stone-900 leading-tight">{title}</h3>
              <p className="text-[15px] text-stone-600 leading-relaxed mt-2">{body}</p>
            </div>
            <ul className="flex flex-col gap-2">
              {points.map((p) => (
                <li key={p} className="flex items-start gap-2.5 text-sm text-stone-700">
                  <Check className="w-4 h-4 text-[#3EA8DC] shrink-0 mt-0.5" /> {p}
                </li>
              ))}
            </ul>
          </button>
        ))}
      </div>
    </div>
  );
}
